import React, { useState, useRef, useEffect } from "react";
import { AiFillMessage, AiOutlineClose, AiOutlineSend } from "react-icons/ai";
import "./ChatBot.css";

function ChatBot() {
    const [isOpen, setIsOpen] = useState(false);
    const [messages, setMessages] = useState([
        { id: 1, text: "Hi there! I'm Anupam's AI Assistant. How can I help you today?", role: "bot" }
    ]);
    const [inputText, setInputText] = useState("");
    const messagesEndRef = useRef(null);

    const toggleChat = () => {
        setIsOpen(!isOpen);
    };

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        scrollToBottom();
    }, [messages, isOpen]);

    const handleSendMessage = (e) => {
        e.preventDefault();
        if (!inputText.trim()) return;

        const newMessage = {
            id: Date.now(),
            text: inputText,
            role: "user"
        };

        setMessages((prev) => [...prev, newMessage]);
        setInputText("");

        // Simulate bot response
        setTimeout(() => {
            const botResponse = {
                id: Date.now() + 1,
                text: "Thanks for your message! This is a demo chat widget. Anupam will convert this to a real AI soon.",
                role: "bot"
            };
            setMessages((prev) => [...prev, botResponse]);
        }, 1000);
    };

    return (
        <div className="chat-widget-container">
            {isOpen && (
                <div className="chat-window">
                    <div className="chat-header">
                        <h3>AI Assistant</h3>
                        <button onClick={toggleChat} className="close-btn">
                            <AiOutlineClose />
                        </button>
                    </div>
                    <div className="chat-body">
                        {messages.map((msg) => (
                            <div key={msg.id} className={`message ${msg.role}`}>
                                {msg.text}
                            </div>
                        ))}
                        <div ref={messagesEndRef} />
                    </div>
                    <form className="chat-footer" onSubmit={handleSendMessage}>
                        <input
                            type="text"
                            className="chat-input"
                            placeholder="Type a message..."
                            value={inputText}
                            onChange={(e) => setInputText(e.target.value)}
                        />
                        <button type="submit" className="send-btn" disabled={!inputText.trim()}>
                            <AiOutlineSend />
                        </button>
                    </form>
                </div>
            )}
            <button onClick={toggleChat} className="chat-toggle-btn">
                <AiFillMessage />
            </button>
        </div>
    );
}

export default ChatBot;
